import type { AnchorConfigProtocol } from '@lighthouse/core'
import { AnchorBehaviorEnum } from '@lighthouse/core'
import { useMount } from 'react-use'

import { useAnchorHashContext } from '../context/AnchorHashContext'

/**
 * Block 挂载到 DOM 后，若 hash 与 effectiveAnchorId 匹配则滚动到该 block
 * hash 从 AnchorHashProvider 获取（pageStack atom）；未提供时从 URL 获取（runner navigate 方式）
 * offset: x 负左正右, y 负下正上
 * behavior 默认 instant
 */
export function useScrollToAnchorWhenHashMatch(effectiveAnchorId: string | undefined, anchor?: AnchorConfigProtocol): void {
    const contextHash = useAnchorHashContext()
    const effectiveHash = (contextHash ?? (typeof window !== 'undefined' ? window.location.hash : '')).replace(/^#/, '')

    useMount(() => {
        if (!effectiveAnchorId || typeof window === 'undefined' || !anchor) return

        if (effectiveHash !== effectiveAnchorId) return

        requestAnimationFrame(() => {
            const el = document.getElementById(effectiveAnchorId)
            if (!el) return
            el.scrollIntoView({ behavior: (anchor?.behavior ?? AnchorBehaviorEnum.INSTANT) as ScrollBehavior })
        })
    })
}
